import { render } from "./SalaryReportsDataTable.vue?vue&type=template&id=3ce0a077&scoped=true&ts=true"
import script from "./SalaryReportsDataTable.vue?vue&type=script&lang=ts"
export * from "./SalaryReportsDataTable.vue?vue&type=script&lang=ts"

import "./SalaryReportsDataTable.vue?vue&type=style&index=0&id=3ce0a077&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce0a077"]])

export default __exports__